import React from 'react';

import TextArea from '../TextArea';

function TextInput({id, label, question, values, onChange, invalid, disabled}) {
  const answer = values.length > 0 ? values[0] : '';

  return (
    <TextArea
      id={id ? id : `answer-${question.id}`}
      label={label}
      invalid={invalid}
      disabled={disabled}
      value={answer}
      onChange={e => onChange([e.target.value], true)}
    />
  );
}

export default TextInput;
